import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const TextInput = forwardRef((props, ref) => {
    return (
        <input
            className='w-full bg-sand border-grey type-style-8 rounded-button placeholder:text-placeholder'
            ref={ref}
            type='text'
            {...props} />
    );
});

TextInput.displayName = 'TextInput';

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

TextInput.propTypes = {};

export default TextInput;
